import styled from 'styled-components';
import Edit from '@material-ui/icons/Edit';

import THEME from '../../../../../../../constants/theme';

export const Container = styled.div``;

export const EditButton = styled(Edit)`
  font-size: 13px !important;
  margin-left: 5px;
`;

export const Text = styled.div`
  display: inline;
  margin: 0;
`;

export const HoverText = styled(Text)`
  &:hover {
    background: ${THEME.lightGrey};
    border-radius: 4px;
    cursor: pointer;
    padding: 2px;
  }
`;

export const style = {
  container: {
    margin   : 0,
    minHeight: 22,
  },
  icon: {
    display: 'none',
  },
  input: {
    border      : `1px solid ${THEME.primary}`,
    borderRadius: 4,
    fontFamily  : 'Montserrat',
    fontSize    : 14,
    fontWeight  : 500,
    height      : 20,
    padding     : 0,
    paddingLeft : 3,
  },
  label: {
    display: 'none',
  },
};
